import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=ba4a55a4&scoped=true&"
import script from "./Nodata.vue?vue&type=script&lang=js&"
export * from "./Nodata.vue?vue&type=script&lang=js&"
import style0 from "./Nodata.vue?vue&type=style&index=0&id=ba4a55a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4a55a4",
  null
  
)

export default component.exports